import moment from 'moment';

// getYear :: ISODate|String -> Number
const getYear = date => moment(date).year();

export default getYear;
